module.exports = __webpack_public_path__ + "img/img_04.96a1f270.png";